export default "__VITE_ASSET__013c3a68__"